

<div class="c-search">
    <h4 class="c-search__subtitle">Digite o número do documento no campo abaixo para verificar sua autenticidade.</h4>
    <form class="c-search__form" (ngSubmit)="onVerifyDiploma()" [formGroup]="form">
        <input type="text" class="c-search__form--input" formControlName="diplomaNumber" placeholder="Digite o número do documento">
        <div>            
            <button mat-flat-button class="c-search__form--btn" [ngClass]="{'c-search__form--disabled': isLoading}"
                    [disabled]="isLoading"
                    color="primary">                
                <i class="fas fa-spinner fa-spin" *ngIf="isLoading"></i>
                {{ isLoading ? 'LOCALIZANDO' : 'LOCALIZAR' }}
            </button>
        </div>
    </form>
</div>